(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './ModalContext'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./ModalContext'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ModalContext);
    global.ModalConsumer = mod.exports;
  }
})(this, function (exports, _ModalContext) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _ModalContext2 = _interopRequireDefault(_ModalContext);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /*
    When React renders a context Consumer, it will read the current context value
    from the closest matching Provider above it in the tree.
  
    See: https://reactjs.org/docs/context.html#consumer
  */

  var ModalConsumer = _ModalContext2.default.Consumer;

  exports.default = ModalConsumer;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/ModalManager/ModalConsumer.js
// module id = 863
// module chunks = 1